import { Container, Grid } from '@mui/material';
import React from 'react';
import Heading from '../components/heading'
import Accordian from '../components/accordian';
import { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

const FAQ = () => {
    useEffect(() => {
        AOS.init({
          duration: 800,
          offset: 200,
        });
      }, []);
    
      useEffect(() => {
        AOS.refresh();
      });
    return(
        <Container maxWidth = 'lg' id='faq'>
          <Grid container>
            <Heading
              title = 'FAQ'
              p = '5% 0% 1%'
            />
            <Grid xs={12} data-aos="fade-up" data-aos-anchor-placement="center-bottom">
              <Accordian/>
            </Grid>
          </Grid>
        </Container>
    )
}
export default FAQ;